import WarningPopup from 'components/WarningPopup'
import React, { useState, useCallback, useEffect } from 'react'
import { useIdleTimer } from 'react-idle-timer'

function useIdleTimeout({ timeout, warningTime, onIdle, onLogout }) {
  const [showWarning, setShowWarning] = useState(false)
  const [countdown, setCountdown] = useState(warningTime / 1000) // countdown in seconds

  const logoutUser = useCallback(() => {
    setShowWarning(false)
    if (onLogout) onLogout()
  }, [onLogout])

  useEffect(() => {
    let interval
    if (showWarning && countdown > 0) {
      interval = setInterval(() => {
        setCountdown((count) => count - 1)
      }, 1000)
    } else if (countdown <= 0) {
      logoutUser()
    }
    return () => clearInterval(interval)
  }, [showWarning, countdown])

  const handleOnIdle = () => {
    setShowWarning(true)
    setCountdown(warningTime / 1000)
    if (onIdle) onIdle()
  }

  const { reset } = useIdleTimer({
    timeout,
    onIdle: handleOnIdle,
    debounce: 500
  })

  const confirmActivity = useCallback(() => {
    reset()
    setShowWarning(false)
    setCountdown(warningTime / 1000) // Reset countdown as part of activity confirmation
  }, [reset, warningTime])

  const WarningPopupComponent = () => {
    return <WarningPopup open={showWarning} countdown={countdown} onConfirm={confirmActivity} />
  }
  return { WarningPopup: WarningPopupComponent }
}
export default useIdleTimeout
